export function setAll(state, { all }) {
  state.all = all;
}

export function setSingle(state, { single }) {
  state.single = single;
}
